import { render, staticRenderFns } from "./column_video.vue?vue&type=template&id=7339950b&scoped=true"
import script from "./column_video.vue?vue&type=script&lang=js"
export * from "./column_video.vue?vue&type=script&lang=js"
import style0 from "./column_video.vue?vue&type=style&index=0&id=7339950b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7339950b",
  null
  
)

export default component.exports